import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { InterventionCard } from '../../interventions/InterventionCard';

export function SelectCustomIntervention() {
	const { dispatch } = useGoalsAndInterventionsWizard();

	const onCustomInterventionSelect = () => {
		const newInterventionId = crypto.randomUUID();
		dispatch({ type: 'CUSTOM_INTERVENTION_SELECTED', newInterventionId });
	};

	return (
		<InterventionCard
			interventionDefinition={{
				title: 'Custom',
				definitionText: 'Custom intervention definition',
				documentationWorkflows: [],
				restrictedToClinicalTypes: []
			}}
			selection={{
				selected: false,
				onSelect: () => onCustomInterventionSelect()
			}}
		/>
	);
}
